import { OnInit, ElementRef, OnDestroy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { MediaModel } from 'src/app/story/models/media.model';
import { takeUntil, filter } from 'rxjs/operators';
var ViewAudioComponent = /** @class */ (function () {
    // ---------- Lifecyle Events ----------
    function ViewAudioComponent(changeRef) {
        this.changeRef = changeRef;
        this.playingChange = new EventEmitter();
        this.readyChange = new EventEmitter();
        // ---------- Class Variables ----------
        this.mediaSupportCache = {};
        this.source = '';
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(ViewAudioComponent.prototype, "media", {
        get: function () {
            return this._media;
        },
        // ---------- Input / Output ----------
        set: function (value) {
            if (!value) {
                return;
            }
            this.setMedia(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewAudioComponent.prototype, "playing", {
        get: function () {
            return this._playing;
        },
        set: function (value) {
            if (value === this.playing) {
                return;
            }
            this._playing = value;
            this.playingChange.emit(this.playing);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewAudioComponent.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        set: function (value) {
            if (value === this.ready) {
                return;
            }
            this._ready = value;
            this.readyChange.emit(this.ready);
        },
        enumerable: true,
        configurable: true
    });
    ViewAudioComponent.prototype.ngOnInit = function () {
        this.initMediaEvents();
        this.initMediaPlayback();
    };
    ViewAudioComponent.prototype.ngOnDestroy = function () {
        // cleanup audio
        this.pause();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Class Methods ----------
    ViewAudioComponent.prototype.play = function () {
        if (this.ready) {
            this._audioEl.play();
        }
    };
    ViewAudioComponent.prototype.pause = function () {
        if (this.ready) {
            this._audioEl.pause();
        }
    };
    ViewAudioComponent.prototype.reset = function () {
        this.pause();
        this.time = 0;
        this.playing = false;
        this.ready = false;
        this.error = false;
        this.changeRef.markForCheck();
    };
    ViewAudioComponent.prototype.setMedia = function (media) {
        this._media = media;
        this.source = "/content/states/" + this.media.data.fullUrl;
        this.initMediaPlayback();
    };
    ViewAudioComponent.prototype.initMediaPlayback = function () {
        // clear existing
        this.autoPlay = this.playing;
        this.reset();
    };
    ViewAudioComponent.prototype.initMediaEvents = function () {
        var _this = this;
        // set audio el
        this._audioEl = this.audioElRef.nativeElement;
        // set initial state
        this.reset();
        // track ready state
        fromEvent(this._audioEl, 'loadeddata')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.ready = _this._audioEl.readyState > 0;
        });
        // track playing
        fromEvent(this._audioEl, 'play')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.playing = true;
            _this.changeRef.markForCheck();
        });
        // track pause
        fromEvent(this._audioEl, 'pause')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.playing = false;
            _this.changeRef.markForCheck();
        });
        // track time
        fromEvent(this._audioEl, 'timeupdate')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.time = _this._audioEl.currentTime;
        });
        // handle auto-play
        fromEvent(this._audioEl, 'canplay')
            .pipe(filter(function () { return !_this.playing && _this.autoPlay; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.play();
        });
        // handle errors
        fromEvent(this._audioEl, 'error')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.error = true;
        });
    };
    return ViewAudioComponent;
}());
export { ViewAudioComponent };
